import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Response_codes extends PureComponent {
  render() {
    return (
      <div className="row" id="response_codes">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Response Codes</h2>
              <p>
                REST APIs use the HTTP response codes to inform their developers
                of success or failure. A 200 response code means your API
                request was successful. Response codes in the 4xx range tells
                you there was an error on the client-side typically permissions
                or missing resource. Response codes in the 5xx range tells you
                the server has experienced an error.
              </p>
              <h3>Response Code Table</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top" style={{ width: 50 }}>
                      2xx
                    </td>
                    <td className="top">
                      The action was completed successfully
                    </td>
                  </tr>
                  <tr>
                    <td className="b">200</td>
                    <td>OK</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td className="b top" style={{ width: 50 }}>
                      4xx
                    </td>
                    <td className="top">
                      A client side error; incorrect format, forbidden,
                      unauthorised or not found
                    </td>
                  </tr>
                  <tr>
                    <td className="b">400</td>
                    <td>Bad Request</td>
                  </tr>
                  <tr>
                    <td className="b">401</td>
                    <td>
                      Unauthorized: you do not have access to this particular
                      object / function or your session has expired
                    </td>
                  </tr>
                  <tr>
                    <td className="b">403</td>
                    <td>Forbidden: most likely an incorrect API URL</td>
                  </tr>
                  <tr>
                    <td className="b">404</td>
                    <td>Object or resource not found</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td className="b top" style={{ width: 50 }}>
                      5xx
                    </td>
                    <td className="top">Server side or logical error</td>
                  </tr>
                  <tr>
                    <td className="b">500</td>
                    <td>
                      Internal server error could be due to malformed JSON in
                      request
                    </td>
                  </tr>
                  <tr>
                    <td className="b">504</td>
                    <td>Service timed out</td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Response_codes;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Response_codes.js